import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { Container, Row, Col, Card, CardHeader, CardBody, CardText } from "reactstrap"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "components/Common/Breadcrumb"
import axios from "axios"
import { API_URL, sitename } from "constants/constants"
import moment from "moment"
import { Filters } from "./Filters"
import Table from "./Table"

const BookABetReport = props => {
  const [bookBetReport, setBookBetReport] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [loadingMessage, setLoadingMessage] = useState("1")

  useEffect(() => {
    call()
  }, [])

  const call = () => {
    setLoadingMessage("1")
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/book-a-bet-reports?to=${toDate}&from=${fromDate}`,
    })
      .then(function (response) {
        setBookBetReport(response?.data?.data)
        setLoadingMessage("0")
      })
      .catch(function (response) {})
  }

  // Calculate total values from the API response
  const calculateTotals = () => {
    let totalTickets = 0
    let totalStakes = 0
    let totalPayout = 0
    let totalGGR = 0

    bookBetReport.forEach(data => {
      totalTickets += data.bets
      totalStakes += data.total_stake
      totalPayout += data.payout
      totalGGR += data.GGR
    })

    return { totalTickets, totalStakes, totalPayout, totalGGR }
  }

  const totals = calculateTotals()

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Book-A-Bet Report" />
        </Container>
        <Row>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Tickets</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totals.totalTickets}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Stakes</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totals.totalStakes}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Payout</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totals.totalPayout}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">GGR</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totals.totalGGR}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Filters
          toDate={toDate}
          fromDate={fromDate}
          setToDate={d => setToDate(d)}
          setFromDate={d => setFromDate(d)}
          call={call}
        />
        <Table data={bookBetReport} setLoadingMessage={setLoadingMessage} loadingMessage={loadingMessage} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(BookABetReport)
